export class commonAll {
}
commonAll.STORE_MODULE_NAME = 'commonAll';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/lib/commonAll.cls.ts
// module id = null
// module chunks = 